module.exports = __webpack_public_path__ + "img/faq.14f0eb1c.svg";